import axios, { CancelToken, isCancel } from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.withCredentials = true;

const axiosCore = axios.create({
  baseURL: process.env.REACT_APP_MEMAS_CORE,
});

axios.interceptors.response.use(
  res => res,
  err => {
    const is401 = err.response?.status === 401;
    const publicRoutes = ['/login', '/signup'];
    const isPublicPage = publicRoutes.includes(window.location.pathname);

    if (is401 && !isPublicPage) {
      window.location.replace('/login');
    }

    return Promise.reject(err);
  },
);

export { axiosCore, CancelToken, isCancel };
export default axios;
